export function changeCancelButton(btn) {
    const button = document.getElementById(btn);
    const tabContentId = document.getElementById('infoTab');

    function toggleContent(tab) {
        tab.checked = true;
    }

    button.addEventListener('click', function () {
        toggleContent(tabContentId);
    });
}